import { ArrowBack } from '@mui/icons-material'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const NotFoundPage: FC = () => {
  const { t } = useTranslation('common', { keyPrefix: 'error' })
  const theme = useTheme()
  const navigate = useNavigate()

  return (
    <Box
      data-testid="not-found-page"
      sx={{
        display: 'flex',
        placeContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          color: theme.palette.divider,
          padding: theme.spacing(5),
          border: `10px solid ${theme.palette.divider}`,
          [theme.breakpoints.up('xs')]: {
            fontSize: '8.625rem',
          },
          [theme.breakpoints.up('sm')]: {
            fontSize: '13.125rem',
            borderWidth: '15px',
          },
          [theme.breakpoints.up('md')]: {
            fontSize: '17.5rem',
          },
          [theme.breakpoints.up('lg')]: {
            fontSize: '23.75rem',
            borderWidth: '20px',
          },
        }}
      >
        {t('code.404')}
      </Typography>
      <Typography
        variant="h1"
        component="h2"
        sx={{
          mt: 5,
          mb: 4,
        }}
      >
        {t('code.text.404')}
      </Typography>
      <Typography variant="bodyLarge" component="p" sx={{}}>
        {t('code.description.404')}
      </Typography>
      <Button
        data-testid="go-home-button"
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
        sx={{
          mt: 4,
        }}
      >
        <ArrowBack sx={{ mr: 1 }} />
        {t('go.home', { keyPrefix: 'button' })}
      </Button>
    </Box>
  )
}

export default NotFoundPage
